export const USER_LOADING = "USER_LOADING";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOADED = "USER_LOADED";
export const BUSINESS_CAL_JAVA_COFFEE = "636bd5a1e578d7ee1654ea49";
export const IS_LOGIN_USER = "IS_LOGIN_USER";
